





















import UiImage from '../UiImage'
export default {
  name: 'UiBadge',
  components: {
    UiImage
  }
}
